import "./HazardousAreaProcessAnalysis.module.css";
import Header from "@/reusable_sections/Header";
import HazardousHero from "./sections/HazardousHero";
import ZoneChallenges from "./sections/ZoneChallenges";
import RelatedSolutions from "./sections/RelatedSolutions";
import HazardousFamilies from "./sections/HazardousFamilies";
import HazardousResources from "./sections/HazardousResources";
import SupportServices from "./sections/SupportServices";
import HazardousCta from "./sections/HazardousCta";
import Footer from "@/reusable_sections/Footer";
export default function HazardousAreaProcessAnalysisPage() {
  return <div>
      <Header />
      <HazardousHero />
      <ZoneChallenges />
      <RelatedSolutions />
      <HazardousFamilies />
      <HazardousResources />
      <SupportServices />
      <HazardousCta />
      <Footer />
    </div>;
}